module.exports = __webpack_public_path__ + "images/276087fe621ae01f0afe4880c8b27541.svg";